<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Admin"
            bc1="App"
            bc2="Admin"
            bc3="List"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-md-4 col-sm-6">
                <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
              </div>
              <div class="col-md-4 col-sm-12">
                <button type="button" class="btn btn-primary" @click="onSubmitFilters" >Search</button>
                <button type="button" class="ml-1 btn btn-danger "  @click="clear">Clear</button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="$router.push({ name: 'admin-add' })"
                  >
                    <AddButtonText name="Admin" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
            :url="url"
            :tableHeaderValues="tableHeaderValues"
            :actions="actions"
            :deleteActions="deleteActions"
            :mutedData="mutedData"
            :storageKey="storageKey"
            :externalTotalRecord="externalTotalRecord"
            :controlStatusToggle="controlStatusToggle"
            :show-per-page="true"
            :filteredData="filteredData"
          />
        </div>
      </div>
    </div>
    <ConfirmationModal :show="showConfirmationModal" @confirm="confirmResetPassword" message="Are you sure to reset the password?"
                       title="Reset Password"
                       @hide="showConfirmationModal = false"></ConfirmationModal>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {AddButtonText, CommandIcon },
  mounted() {
    localStorage.setItem("url", "v1/get-admin-user");
    this.checkDataInStore('v1/get-admin-user')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      showConfirmationModal: false,
      selectedUserIdForPassReset:'',
      filteredData: { flag: "all", type: 1 },
      url: "v1/get-admin-user",
      storageKey: "AdminUser",
      isDefault: false,
      tableHeaderValues: [
        {
          title: "First Name",
          valueKey: "first_name"
        },
        {
          title: "Last Name",
          valueKey: "last_name"
        },
        {
          title: "Email",
          valueKey: "email"
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
              if(row.status_reason){
                html = `
                <div class="row">
                <div class="col-12">
                ${html}
                </div><p><div class="badge badge-light-danger ml-1" style="margin-top: 0.3rem">${row.status_reason}</div></p></div>`
              }
            }


            return html;
          }
        }
      ],
      actions: [
        //{
        //  title: "Manage User",
        //  cta: (row, index) => {
        //    let data = {
        //      index: index,
        //      row: row,
        //      key: "adminUserUpdate"
        //    };
        //    this.$store.dispatch("set", data);
        //    this.$router.push({ name: "admin-update" });
        //  }
        //},
        {
         title: "Assign Roles",
          class: "btn btn-sm btn-secondary badge",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "userRoles"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "user-roles",params: {userId :row.id}})
          }
        },
        {
          title: "Reset Password",
          // conditionalRendering: true,
          class: "btn btn-sm btn-primary badge",
          // condition: (row)=>{
          //   var loginData = this.$store.getters.getByKey(
          //       "login"
          //   );
          //   if(loginData){
          //     if(loginData.row){
          //       if(loginData.row.user_type == 1 && loginData.row.parent_user_id == 0){
          //         return true
          //       }
          //     }
          //   }
          //
          //   return false
          // },
          cta: (row, index) => {
            this.selectedUserIdForPassReset = row.id
            this.showConfirmationModal = true
          }
        },
        {
          title: 'Logs',
          class: "badge badge-sm badge-warning",

          cta: (row) => {

            let propFilters = {}
            this.$router.push({name: 'get-logs',params: {id:row.uuid,propFilters: propFilters}})
          },

        },
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index, key,oldStatus) => {
            if(oldStatus == 2){
              row.status = true
            }
            let data = {
              index: index,
              row: row,
              key: "adminUserDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: "",
      search: "",
    };
  },
  methods: {
    onSubmitFilters() {
      let filterData = { flag: "all", type: 1 }

      if(this.search != ''){
        filterData.searchKeyWord = this.search
      }

      this.filteredData = filterData

    },
    clear(){
      this.search = ''
      this.filteredData = { flag: "all", type: 1 }

    },
    confirmResetPassword(){
      this.resetPass()
    },
    controlStatusToggle(row,status){
      if(status == 2){
        return false
      }
      return status
    },
    resetPass(){
      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest("post", "v1/update-user-status", {
        status: 1 ,
        userId: this.selectedUserIdForPassReset,
        resetPassword: 1
      }).then(callResponse => {
        this.$store.dispatch('exportExcelLoader', false)
        this.showConfirmationModal = false
      });
    },
    deleteRecord(data) {
      this.makeRequest("post", "v1/update-user-status", {
        status: data.row.status == true ? 1 : 0,
        userId: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey("AdminUser");
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "AdminUser";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>
